import { schedularTherapistFilterAction } from 'src/redux/actions/constant';


const intialState: object = {
  response: null,
  deleteSplitTask: false,
  loading: false,
};

export const deleteSplitTaskReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case schedularTherapistFilterAction.DELETE_SPLIT_TASK_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        deleteSplitTask: true,
        loading: false,
      };
    }
    case  schedularTherapistFilterAction.DELETE_SPLIT_TASK_FAILURE : {
      return {
        ...state,
        response: action.payload,
        deleteSplitTask: false,
        loading: false,
      };
    }

    case schedularTherapistFilterAction.DELETE_SPLIT_TASK_LOADING:
      return {
        ...state,
        loading: true,
      };

    case schedularTherapistFilterAction.DELETE_SPLIT_TASK_RESET:
      return intialState   


    default:
      return state;
  }
};
